import React from 'react';
import { Grid } from '@mui/material';
import { CreateAccountForm } from './CreateAccountForm';
import { useCreateMetaApiCloudAccountMutation } from '../../../../shared/types/generated';
import { useAuth } from '../../../auth/auth-hooks';
import { useNavigate } from 'react-router-dom';

export const Account: React.FC = () => {
  const navigate = useNavigate();

  const { user, refetch } = useAuth();
  const [callAction, { loading }] = useCreateMetaApiCloudAccountMutation({

    onCompleted: () => {
      refetch();
      navigate('/', { state: { redirectTo: '/' } });
    },
  });


  return (
    <Grid container justifyContent='center' alignItems='center'>
      <Grid item xs={12} md={3}>
        <CreateAccountForm
          successLoading={loading}
          onSuccess={(data) => {
            if (data) {
              const { _id: accountId, baseCurrency: currency, login, name, region, server, version } = data;
              callAction({
                variables: {
                  data: {
                    currency,
                    account_id: accountId,
                    login,
                    name,
                    region,
                    server,
                    version,
                    user: {
                      connect: {
                        id: user?.id,
                      },
                    },
                  },
                },
              });
            }
          }}
        />
      </Grid>
    </Grid>
  );
};
